import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import {
  NODE_PARAGRAPH,
  render,
  MARK_LINK,
} from 'storyblok-rich-text-react-renderer';
import FancyTitle from '../fancy-title';
import LinkResolver from '../../helpers/link-resolver';
import Container from '../Container';

export default function CardsSection({ blok }) {
  if (!blok.cards.length) {
    return null;
  }

  const cardsLength = blok.cards.length > 2 ? 3 : 2;

  const Wrapper = blok.use_container ? Container : React.Fragment;

  return (
    <div
      {...storyblokEditable(blok)}
      className=""
    >
      <Wrapper className={`pb-24 pt-6 grid grid-cols-1 lg:grid-cols-${cardsLength} gap-20 lg:gap-4 xl:gap-20 highlighted-wrapper`}>
        {blok.cards.map((card, i) => (
          <div
            className="px-5 pt-5 pb-10 border-2 border-solid rounded border-latori-green-dark"
            key={`t-${card.Title}`}
          >
            <div className="flex items-center w-full dark">
              <style type="text/css">
                {`
            .highlighted-wrapper > div:nth-child(${
              i + 1
            }) .green-background-highlight::before {
              top: ${'6%'}%;
              right: ${'35%'}%;
            }
            `}
              </style>
              <FancyTitle
                text={card.Title}
                marginBottom=""
                fontSize="text-2xl"
                className="fancy-title-small w-[calc(100%+16px)] p-[10px] hyphens-auto
            bg-background-dark text-white green-background-highlight mx-[-10px]"
                tag="h3"
              />
            </div>
            <div className="pt-6 card-section-content">
              {render(card.content, {
                markResolvers: {
                  [MARK_LINK]: LinkResolver,
                },
                nodeResolvers: {
                  // eslint-disable-next-line react/no-unstable-nested-components
                  [NODE_PARAGRAPH]: (children) => (
                    <p className="m-auto first-of-type:mt-0 last-of-type:mb-0">
                      {children}
                    </p>
                  ),
                },
              })}
            </div>
          </div>
        ))}
      </Wrapper>
    </div>
  );
}
